module.exports = __webpack_public_path__ + "static/img/s05.ae9da472.png";